import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CollectionPurposeDataProvider } from "../../data-provider/collection-purpose.dp";
import { DataRecordDataProvider } from "../../data-provider/data-record.dp";
import { DataRecordHelper } from "../data-record/data-record.helper";
import { DataSetDataProvider } from "../../data-provider/data-set.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Campaign } from "../../models/campaign.model";
import { Field } from "../../models/field.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { PrivacyNoticeDataProvider } from "../../data-provider/privacy-notice.dp";
import { Utils } from "../../helper/utils.helper";

let PrivacyComponent = {
    selector: "vcPrivacyDashboard",
    templateUrl: "/angular/components/privacy/privacy-dashboard.component.html",
    bindings: {},
    controller: class PrivacyController {
        private __env;
        private $mdDialog;
        private $window;
        private utils: Utils;
        private $cookies: any;
        private $route: any;

        public activeUser: User;
        public datarecordlog: any;
        public dataSetDataProvider: DataSetDataProvider;
        public dataProvider: PrivacyNoticeDataProvider;
        public userDataProvider: UserDataProvider;
        public dataRecordHelper: DataRecordHelper;
        public dataRecordDataProvider: DataRecordDataProvider;
        public permissionProvider: PermissionCheck;
        public resultDataProvider: ResultDataProvider;
        public toast: ToastUtils;
        public dialog: DialogUtils;
        public datapoints: Array<any>;
        public fields: Field[];
        public campaigns: Array<any>;
        public campaign: Campaign;
        public privacyNotices: Array<any>;
        public officerinfo;
        public readonly MONTHS = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        public ownerinfo;
        public consentSettings;
        public securitySettings;
        public createdApps: Array<any>;
        private readonly $scope: any;
        private collectionPurposeDataProvider: CollectionPurposeDataProvider;

        constructor(
            $scope: any,
            Utils: Utils,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            $mdDialog: any,
            $window: any,
            PermissionCheck: PermissionCheck,
            __env: any,
            $cookies: any,
            $route: any,
            PrivacyNoticeDataProvider: PrivacyNoticeDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            CollectionPurposeDataProvider: CollectionPurposeDataProvider,
            DataSetDataProvider: DataSetDataProvider,
            DataRecordDataProvider: DataRecordDataProvider,
            UserDataProvider: UserDataProvider,
            DataRecordHelper: DataRecordHelper,
            FieldDataProvider: FieldDataProvider,
            ResultDataProvider: ResultDataProvider
        ) {
            this.utils = Utils;
            this.dialog = DialogUtils;
            this.utils.accessCheck();
            this.$mdDialog = $mdDialog;
            this.$window = $window;
            this.toast = ToastUtils;
            this.__env = __env;
            this.$scope = $scope;
            this.$cookies = $cookies;
            this.$route = $route;
            this.permissionProvider = PermissionCheck;
            this.dataProvider = PrivacyNoticeDataProvider;
            this.userDataProvider = UserDataProvider;
            this.resultDataProvider = ResultDataProvider;
            this.dataSetDataProvider = DataSetDataProvider;
            this.dataRecordDataProvider = DataRecordDataProvider;
            this.dataRecordHelper = DataRecordHelper;
            this.campaign = CampaignDataProvider.getActiveCampaign();
            this.collectionPurposeDataProvider = CollectionPurposeDataProvider;

            this.collectionPurposeDataProvider
                .points()
                .then((points: Array<any>) => {
                    this.datapoints = points;
                });

            this.userDataProvider
                .getUser(this.utils.activeUid())
                .then((user) => {
                    this.activeUser = user;
                });

            CampaignDataProvider.allCampaigns().then((campaigns) => {
                this.campaigns = campaigns;
            });

            DataRecordDataProvider.getAllDataRecords().then((datarecordlog) => {
                this.datarecordlog = datarecordlog;
            });

            FieldDataProvider.getAllFields().then((fields) => {
                this.fields = fields;
            });

            CampaignDataProvider.info(this.campaign.campaignid).then(
                (campaign) => {
                    this.ownerinfo = campaign.relationships.owner.data;

                    this.permissionProvider
                        .getConsentSettings()
                        .then((consentSettings) => {
                            this.consentSettings = consentSettings;
                        });

                    this.permissionProvider
                        .getSecuritySettings()
                        .then((securitySettings) => {
                            this.securitySettings = securitySettings;
                        });
                }
            );

            this.collectionPurposeDataProvider
                .getOfficer()
                .then((officer: object) => {
                    if (angular.isDefined(officer)) {
                        this.officerinfo = officer;
                    }
                })
                .then(() => {
                    this.dataProvider
                        .getAllPrivacyNotices()
                        .then((privacyNotices: Array<any>) => {
                            this.privacyNotices = privacyNotices.map((pn) => {
                                if (pn.pnid == 1) {
                                    // Replace sample data
                                    pn.pnheader = pn.pnheader.replace(
                                        "<<Campaign Name>>",
                                        this.campaign.campaignname
                                    );
                                    var now = new Date();
                                    pn.pnbody = pn.pnbody
                                        .replace(
                                            "&lt;&lt;dpo email&gt;&gt;",
                                            this.officerinfo
                                                ? this.officerinfo.oemail
                                                : "[Replace with DPO email]"
                                        )
                                        .replace(
                                            "&lt;&lt;DD MM YYYY&gt;&gt;",
                                            this.MONTHS[now.getMonth()] +
                                                " " +
                                                now.getDate() +
                                                ", " +
                                                now.getFullYear()
                                        );
                                }

                                return pn;
                            });
                        });
                });
        }

        openAnonymisePersonalDataModal($event: any): void {
            this.dialog
                .show({
                    component: "vc-data-set-anonymise-dialog",
                    targetEvent: $event,
                    size: "large",
                    scope: this.$scope,
                })
                .then((response: { consentedType: any; status: string }) => {
                    if (angular.isDefined(response)) {
                        this.dataSetDataProvider
                            .anonymize(response.consentedType)
                            .then(
                                () => {
                                    this.toast.success(
                                        "Anonymization started..."
                                    );
                                    if (this.resultDataProvider.isDummyData()) {
                                        this.resultDataProvider.dismissDummyData();
                                        this.$cookies.put(
                                            "dismissedDummy",
                                            this.resultDataProvider
                                                .dismissedDummy
                                        );
                                        this.$route.reload();
                                    }
                                },
                                (error: object) => this.toast.error(error)
                            );
                    }
                });
        }

        openDataProtectionOfficerModal($event: any, officer: any): void {
            this.dialog
                .show({
                    component: "vc-data-protection-officer-dialog",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {
                        officer: officer,
                    },
                })
                .then((returnedOfficer: any) => {
                    if (angular.isDefined(returnedOfficer)) {
                        if (this.officerinfo) {
                            _.merge(this.officerinfo, returnedOfficer);
                        } else {
                            this.officerinfo = returnedOfficer;
                        }
                        this.toast.success(this.officerinfo.message);
                    } else {
                        this.toast.error();
                    }
                });
        }

        openCollectionPurposeModal(point: any, $event: any): void {
            this.dialog
                .show({
                    component: "vc-collection-purpose-view-dialog",
                    targetEvent: $event,
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        point: point,
                    },
                })
                .then((returnedPoint: object) => {
                    if (angular.isDefined(returnedPoint)) {
                        angular.extend(point, returnedPoint);
                        this.toast.success("Data collection purpose updated");
                    } else {
                        this.toast.error();
                    }
                });
        }

        openDataRecord(ev): void {
            ev.stopPropagation();
            this.dataRecordHelper.openDataRecord(true, false);
        }

        getDataRecordURL(ev, id): void {
            ev.preventDefault();
            ev.stopPropagation();
            this.dataRecordDataProvider
                .getDataRecordURL(id)
                .then((datarecordlink) => {
                    window.open(datarecordlink);
                });
        }

        showDataProtectionAlert(ev): void {
            ev.stopPropagation();
            this.$mdDialog.show(
                this.$mdDialog
                    .confirm()
                    .htmlContent(
                        '<p style="max-width: 500px">' +
                            '<span class="bold">Data Protection</span><br/>' +
                            "In compliance with GDPR Article 13 section 2(a), please complete the name and contact details of the data controller, where applicable, of the controller’s or the processor’s representative, and the data protection officer.</br><br/>" +
                            '<span class="bold">Privacy Compliance</span><br>' +
                            "In compliance with GDPR Article 13 section 2(b), for each data field collected, please update the category of processing carried out.<br/><br/>" +
                            '<a href="' +
                            this.__env.gdpr_link +
                            '" class="md-primary" target="_blank">Learn more</a></p>'
                    )
                    .targetEvent(ev)
                    .ok("OK")
            );
        }

        showConsentSettingsInfo(ev): void {
            ev.stopPropagation();
            this.$mdDialog.show(
                this.$mdDialog
                    .confirm()
                    .htmlContent(
                        '<p style="max-width: 500px">' +
                            "Consent settings allow you to control your reasons for capturing consent. Consent is required of a " +
                            this.__env.strings.voter +
                            " when you wish to have ongoing contact with them.<br/><br/>" +
                            '<a href="' +
                            this.__env.gdpr_link +
                            '" class="md-primary" target="_blank">Learn more</a></p>'
                    )
                    .targetEvent(ev)
                    .ok("OK")
            );
        }
    },
};

angular
    .module("privacy")
    .component(PrivacyComponent.selector, PrivacyComponent);
